export const locales = {
  germany: 'de',
  austria: 'at',
}
